import React, { useState } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';

/**
 * Info-Button mit Dialog: erklärt die drei Sperr-Zustände der Leistungszeilen (R-2-Text).
 * Rein darstellend — kein Bearbeitungsmodus, keine Datenänderung, keine GraphQL-Aufrufe.
 */
// eslint-disable-next-line import/prefer-default-export
export function ServiceLockInfoButton() {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="Warum ist etwas gesperrt?">
        <IconButton
          size="small"
          aria-label="Warum ist etwas gesperrt?"
          sx={{ color: 'text.secondary' }}
          onClick={() => setOpen(true)}
        >
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Wann ist was gesperrt?</DialogTitle>
        <DialogContent>
          <Typography sx={{ fontWeight: 'bold' }}>Zustand 1 – Stift und Mülltonne offen</Typography>
          <Typography>
            Die Leistung wurde noch nie abgerechnet. Ihr könnt alles ändern oder die Zeile löschen.
          </Typography>

          <Typography sx={{ fontWeight: 'bold' }}>Zustand 2 – Mülltonne gesperrt, Stift offen</Typography>
          <Typography>
            Die Leistung wurde schon abgerechnet, und sie ist noch nicht ausgelaufen. Das heißt: Entweder hat sie gar
            kein Enddatum, oder ihr Enddatum liegt im aktuellen Monat oder in einem späteren Monat.
          </Typography>
          <Typography>Löschen geht nicht mehr, weil es Belege dazu gibt.</Typography>
          <Typography>
            Bearbeiten geht: Enddatum setzen, ändern oder wieder entfernen, Preis, Beschreibung, Kundennummer. Nur das
            Startdatum ist gesperrt.
          </Typography>
          <Typography>
            Beispiel: Heute ist der 2. September. Eine laufende Leistung ohne Enddatum soll zum 30. September gekündigt
            werden. Ihr tragt Enddatum September ein. Die Zeile bleibt bis zum 30. September bearbeitbar, ab 1. Oktober
            ist sie zu.
          </Typography>

          <Typography sx={{ fontWeight: 'bold' }}>Zustand 3 – Stift und Mülltonne gesperrt</Typography>
          <Typography>
            Die Leistung wurde schon abgerechnet und ihr Enddatum liegt in einem vergangenen Monat. Die Zeile gehört zur
            Historie und wird nicht mehr angefasst.
          </Typography>
          <Typography>
            Die Sperre greift am 1. des Folgemonats, auch wenn die Abrechnung erst später gemacht wird.
          </Typography>
          <Typography>
            Beispiel: Enddatum September wird ab 1. Oktober gesperrt, obwohl der September erst zum Beispiel am 17.
            Oktober abgerechnet wird.
          </Typography>
          <Typography>Wer die Leistung danach wieder braucht, legt eine neue Zeile an.</Typography>

          <Typography sx={{ fontWeight: 'bold' }}>Drei Regeln beim Bearbeiten (Zustand 2)</Typography>
          <ul>
            <li>
              Das Enddatum darf nicht vor dem letzten abgerechneten Monat liegen. Das System nennt den Monat in der
              Fehlermeldung. Dieser Punkt hängt an der Abrechnung.
            </li>
            <li>Das Enddatum darf nicht vor dem Startdatum liegen.</li>
            <li>
              Preisänderungen gelten ab dem nächsten Abrechnungslauf. Bereits erstellte Belege bleiben, wie sie sind.
            </li>
          </ul>

          <Typography>Ausnahme: alte Abrechnungen bis Mai 2026</Typography>
          <Typography>
            Das System merkt sich die Zuordnung „Beleg gehört zu dieser Leistung“ erst seit Mai 2026. Leistungen, die
            nur davor abgerechnet wurden, gelten für das System als „nie abgerechnet“ und zeigen Zustand 1: Sie lassen
            sich löschen und korrigieren, obwohl es Belege dazu gibt. Das ist kein Fehler, sondern Altbestand.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Schließen</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
